module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_d/main_sp_d37c88d02ed266ead3578da834ffd56a.jpg";